import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	Image,
	TextAlignment,
	AspectRatioContainer,
	CTA,
	Spinner,
	ContainerGutter,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { TelefonoInput } from '../../../oneform/components/telefono-input';
import { GetPersonUser } from '@esportal/portal-service';
import { ElClasicoParticipado } from './el-clasico-participado';
import { PortalContext } from '../../../../context/PortalContext';
import { useErrorAlert } from '../../../../hooks/useErrorAlert';
import { useTrackingManager } from '../../../../tracking/useTrackingManager';
import { getParamsClubVW } from '../../../../helpers/get-params-clubvw';
import { DefaultPromotionData } from '../../promotionPopupLayer';

interface ElClasicoForm {
	name: string;
	data: DefaultPromotionData;
}
export const ElClasicoParticipa: React.FC = () => {
	const { portalService } = React.useContext(PortalContext);
	const { device, tc, url } = getParamsClubVW();
	const trackingManager = useTrackingManager();
	const [participando, setParticipando] = React.useState<boolean>(false);
	const [estadoParticipacion, setEstadoParticipacion] = React.useState<'participa' | 'participado'>('participa');
	const [phoneData, setPhoneData] = React.useState({ prefix: '+34', phoneNumber: '' });
	const { showAlert } = useErrorAlert();

	const promotionName = 'ElClasico2026';

	React.useEffect(() => {
		trackingManager.trackClubVWFormLoad(
			{
				FormName: 'vw-club-ElClasico2026-enroll',
				FormStart: true,
				FormTypeMultiple: ['registration'],
			},
			{ contentId: 'vw-club-ElClasico2026-enroll' },
			{ vehicle: [] },
		);
	}, []);

	const handleParticipate = () => {
		const participateData: ElClasicoForm = {
			name: promotionName,
			data: {
				phonePrefix: phoneData.prefix,
				phoneMobile: phoneData.phoneNumber,
				originDeviceType: device,
				originTrackingCode: tc,
				formUrl: url,
			},
		};

		setParticipando(true);

		portalService.postParticipate(participateData).subscribe({
			next: (response: GetPersonUser | null) => {
				setParticipando(false);

				if (response !== null && response.portalUser.data) {
					const responsePromotion = response.portalUser.data.clubVW.promotions?.find((p) => p.name === promotionName);
					if (responsePromotion?.contestant) {
						setEstadoParticipacion('participado');
						trackingManager.trackClubVWFormSubmissionSuccessMessageLoad(
							{
								FormName: 'vw-club-ElClasico2026-enroll',
								FormStart: false,
								FormTypeMultiple: ['registration'],
							},
							{ contentId: 'vw-club-ElClasico2026-enroll' },
							{ vehicle: [] },
						);
					}
				} else {
					showAlert();
				}
			},
			error: () => {
				setParticipando(false);
				showAlert();
			},
		});
	};

	if (estadoParticipacion === 'participado') {
		return <ElClasicoParticipado />;
	}

	const isFormValid = phoneData.phoneNumber.trim() !== '';

	return (
		<Container
			padding={{
				right: ContainerPadding.dynamic0100,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0100,
			}}
			horizontalAlign={'center'}
			wrap={'always'}
		>
			<AspectRatioContainer data-testid="aspect-ratio-container" ratio="16:9">
				<Image
					src={
						'https://assets.volkswagen.com/is/image/volkswagenag/LaLiga_Clasico_Alerta_NEWBigComposite?Zml0PWNyb3AlMkMxJndpZD0xOTIwJmhlaT04NTgmZm10PWpwZWcmcWx0PTc5JmJmYz1vZmYmNGRhNQ=='
					}
					alt="Imagen el clasico"
					style={{ objectFit: 'cover' }}
				/>
			</AspectRatioContainer>
			<Container
				wrap={'always'}
				padding={{
					top: ContainerPadding.dynamic0130,
				}}
			>
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
					ELCLÁSICO de LALIGA EA SPORTS se empieza a jugar aquí: <Text bold>participa por 1 entrada VIP doble</Text>
				</Text>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Como orgulloso patrocinador de la afición, junto a LALIGA EA SPORTS, te damos la oportunidad de participar
						en un sorteo especial de{' '}
						<Text bold>1 entrada VIP doble para vivir el próximo FC Barcelona vs. Real Madrid del 10 de mayo.</Text>
					</Text>
				</Container>
				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0100,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text bold appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Para apuntarte, solo necesitas indicarnos tu número de teléfono y {window.innerWidth > 960 && <br />} hacer
						click en “participar”.
					</Text>
				</Container>
				<Container
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					gutter={ContainerGutter.dynamic0100}
					wrap={'always'}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<TelefonoInput
						prefix={phoneData.prefix}
						phoneNumber={phoneData.phoneNumber}
						onChange={(data) => setPhoneData(data)}
						required
					/>
				</Container>
				<Container
					padding={{
						top: ContainerPadding.dynamic0050,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<CTA
						tag="button"
						aria-label="CTA bonus redirect"
						size="large"
						disabled={participando || !isFormValid}
						icon={participando ? <Spinner /> : undefined}
						onClick={handleParticipate}
					>
						<Text bold> {participando ? '' : 'Participar'}</Text>
					</CTA>
				</Container>
				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0100,
						bottom: ContainerPadding.dynamic0100,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text
						appearance={TokenTextAppearance.copy100}
						color={TokenTextColor.secondary}
						textAlign={TextAlignment.center}
					>
						{'Consulta las '}
						<CTA
							tag="a"
							aria-label="CTA bases legales"
							size="large"
							emphasis="tertiary"
							onClick={() => {
								window.open(
									'https://www.volkswagen.es/idhub/content/dam/onehub_pkw/importers/es/pdf/Bases-Legales-Promocion-CLUBVWLALIGA_ELCLASICO.pdf',
									'_blank',
								);
							}}
						>
							<Text>bases legales de la promoción </Text>
						</CTA>
						{'\u0020para más información.'}
					</Text>
				</Container>
			</Container>
		</Container>
	);
};
